import Vue from 'vue';

import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import i18n from './locale/i18n';
import click_outside from './directives/click_outside';
import globalMixin from './globalMixin';
import Notifications from 'vue-notification';
import { VueQueryPlugin } from '@tanstack/vue-query';
import { queryClient } from '@/apis/instances/query-client';
import { setAuthTokenProvider } from '@/apis/instances/axios-instance';

// 일렉트론 메인 앱이 전역으로 로드하던 v2 공통 스타일(.cc 등 유틸 클래스, 한글 폰트)
// 일렉트론은 단일 번들이라 예약 창도 이 스타일을 공유받지만, 분리된 웹앱은 명시적으로 로드해야 함
import '@/assets/css/v2/layout.css';
import '@/assets/css/v2/common.css';

// notice 토스트(.push_noti)의 종 아이콘 글리프(\f0f3)용 Font Awesome 폰트. 일렉트론 main.js와 동일하게 로드
import '@fortawesome/fontawesome-free/css/all.css';

export const EventBus = new Vue();

// 일렉트론 메인 앱과 동일한 전역 디렉티브 등록 (예약 메뉴/셀 바깥 클릭 감지용)
Vue.directive(click_outside.name, click_outside.directive);

// 일렉트론 메인 앱과 동일한 전역 mixin 등록
// (this.user / this.hospital 등을 모든 컴포넌트에 주입)
Vue.mixin(globalMixin);

// 알림 토스트 플러그인 (WindowLayer의 notiHandler가 this.$notify 사용)
Vue.use(Notifications);

Vue.config.productionTip = false;

// TanStack Query — 서버 상태 캐싱/중복제거 레이어 (apis/ + composables/api 가 사용)
Vue.use(VueQueryPlugin, { queryClient });

// 신규 apis 레이어의 인증 토큰 provider — Vuex 에 직접 의존하지 않도록 부트스트랩에서 주입
setAuthTokenProvider(() => store.state.user.token);

// 인증은 WindowLayer가 일렉트론 IPC로 처리 (devBootstrap 제거).
// 이 서비스는 항상 일렉트론 위에서 실행되는 전제.
new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App)
}).$mount('#app');
